import React, { useState, useMemo, memo } from "react";
import styles from "./rendimentiCumulatiPerHoldingPeriodTable.module.scss";
import { useTranslation } from "react-i18next";
import colorsStore from "shared/store/colorsStore";
import { formatItalianNumber } from "utils/formatUtils";

type RendimentiCumulatiPerHoldingPeriodTableProps = {
  data: any;
  title?: string;
};

const RendimentiCumulatiPerHoldingPeriodTableComponent: React.FC<
  RendimentiCumulatiPerHoldingPeriodTableProps
> = ({ data, title = "" }) => {
  const dataTable =
    data.analisi_backtest.rendimenti_cumulati_portafoglio_per_holding_period;

  const outputData = [
    { key: "Min", label: "Min" },
    { key: "25 pct", label: "25° pct" },
    { key: "Median", label: "Mediana" },
    { key: "Mean", label: "Media" },
    { key: "75 pct", label: "75° pct" },
    { key: "Max", label: "Max" },
    { key: "% Positive", label: "% periodi positivi" },
  ];
  let columnsNr = 0;
  for (let mc in dataTable) {
    columnsNr++;
    for (let i = 0; i < dataTable[mc].length; i++) {
      const vv = outputData.find((o) => o.key === dataTable[mc][i].label);
      if (vv) {
        vv[mc] = dataTable[mc][i].weight;
      }
    }
  }

  useTranslation();
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);

  const [columns] = useState(columnsNr + 1);
  const totalRows = outputData.length + 1;
  const rows = [];

  for (let rowIndex = 0; rowIndex < totalRows; rowIndex++) {
    const row = rowIndex + 1;

    rows.push(row);
  }
  const cells = useMemo(() => {
    const generatedCells = [];
    for (const row of rows) {
      for (let colIndex = 0; colIndex < columns; colIndex++) {
        const cell = {
          row,
          col: colIndex + 1,
        };

        generatedCells.push(cell);
      }
    }

    return generatedCells;
  }, [rows, columns]);
  const dashValue = (dataValue: any): any => {
    if (!dataValue || dataValue === undefined) {
      return "-";
    }
    return formatItalianNumber(dataValue);
  };

  const renderedCells = useMemo(() => {
    return cells.map((cell) => {
      const { row, col } = cell;

      if (row === 1) {
        return (
          <div
            key={`${row}-${col}`}
            className={[styles.cell, styles.productName].join(" ")}
          >
            {col !== 1 && col - 1}
          </div>
        );
      }
      if (row > 1) {
        if (col === 1 && row > 1) {
          return (
            <div
              key={`${row}-${col}`}
              className={[
                styles.cellKeys,
                row === totalRows ? styles.addBold : null,
                row === totalRows
                  ? styles.cellWithNoBorder
                  : styles.cellWithBorder,
              ].join(" ")}
              style={{
                fontSize: row === 3 ? "44px" : "42px !important",
              }}
            >
              {row > 1 && outputData[row - 2].label}
            </div>
          );
        }

        if (col > 1 && row > 1) {
          return (
            <div key={`${row}-${col}`}>
              <div className={styles.cellValueInnerHeader}>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <div
                      className={[
                        styles.cellValueInnerHeaderValue,
                        row === totalRows ? styles.addBold : null,
                        row === totalRows
                          ? styles.cellWithNoBorder
                          : styles.cellWithBorder,
                      ].join(" ")}
                      style={{
                        textAlign: "center",
                        lineHeight: "40px",
                        color: colorsConfig.FinecoBlack,
                      }}
                    >
                      {row === totalRows ? "" : ""}
                      {col !== 1 && dashValue(outputData[row - 2][col - 1])}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }
      }

      return (
        <div key={`${row}-${col}`} className={styles.cellValue}>
          -
        </div>
      );
    });
  }, [cells, data]);

  return (
    <div className={styles.container}>
      <div className={`${styles.grid} ${styles[`grid${columns}`]}`}>
        {renderedCells}
      </div>
    </div>
  );
};

export const RendimentiCumulatiPerHoldingPeriodTable = memo(
  RendimentiCumulatiPerHoldingPeriodTableComponent,
  (prevProps, nextProps) => {
    return JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data);
  },
);

export default RendimentiCumulatiPerHoldingPeriodTable;
